/**
 * Enums related to Tags
 *
 * @module
 */

/**
 * @enum {string}
 */
exports.locatorType = {
  CSS_SELECTOR: 'css_selector',
  JAVASCRIPT: 'javascript',
  URL_REGEX: 'url_regex',
};

/**
 * @enum {string}
 */
exports.valueType = {
  STRING: 'string',
  NUMBER: 'number',
  CURRENCY: 'currency',
};

/**
 * @enum {string}
 */
exports.nodeNames = {
  INPUT: 'INPUT',
  SELECT: 'SELECT',
};
